import "./App.css";

import AppNavigation from "./routes/AppNavigation";

function App() {
  return (
    <div className="">
      <AppNavigation />
    </div>
  );
}

export default App;
